import React from "react";


export const QualificationNg = () => {

    return (
        <>
        <div className="select_desc al-c">申し訳ございませんが応募できません</div>
		<div className="w-100 mb-100">
            <img src={`${process.env.REACT_APP_HOME_URL}/images/shun.png`} />
        </div>
        </>
    )
}